<script>
  import Tagify from '@yaireo/tagify';
  import '@yaireo/tagify/dist/tagify.css'; // Tagify CSS
  export let selectedItems = [];
  export let suggestedItems = [];
  export let onSelect;
  import { onMount, onDestroy, getContext } from 'svelte';
  let tagify;
  function onAddButtonClick() {
    tagify.addEmptyTag();
  }
  function onInvalidTag(e) {}
  let input;
  onMount(() => {
    tagify = new Tagify(input, {
      pattern:
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      whitelist: suggestedItems,
      maxTags: 5,
      callbacks: {
        invalid: onInvalidTag,
      },
      dropdown: {
        position: 'text',
        enabled: 1,
      },
    }).on('change', (e) => {
      onSelect(tagify.value);
    });
  });
</script>

<button
  type="button"
  class="bg-transparent border-0 shadow-none m-0 p-0 mx-1"
  on:click={onAddButtonClick}
  ><img
    class="icon-12"
    alt=""
    src="/images/plus.svg"
  /></button
>
<label
  for=""
  class="float-end text-muted">Max 5 email allowed</label
>
<input
  class="customLook"
  value={selectedItems.join(',')}
  bind:this={input}
/>

<style lang="scss">
  .customLook .tagify__tag {
    margin-top: 0;
  }

  .customLook .tagify__tag > div {
    border-radius: 25px;
  }

  /* Do not show the "remove tag" (x) button when only a single tag remains */
  .customLook .tagify__tag:only-of-type .tagify__tag__removeBtn {
    display: none;
  }

  .customLook .tagify__tag__removeBtn {
    opacity: 0;
    transform: translateX(-6px) scale(0.5);
    margin-left: -3ch;
    transition: 0.12s;
  }

  .customLook .tagify__tag:hover .tagify__tag__removeBtn {
    transform: none;
    opacity: 1;
    margin-left: -1ch;
  }

  .customLook + button {
    color: #0052bf;
    font: bold 1.4em/1.65 Arial;
    border: 0;
    background: none;
    box-shadow: 0 0 0 2px inset currentColor;
    border-radius: 50%;
    width: 1.65em;
    height: 1.65em;
    cursor: pointer;
    outline: none;
    transition: 0.1s ease-out;
    margin: 0 0 0 5px;
    vertical-align: top;
  }

  .customLook + button:hover {
    box-shadow: 0 0 0 5px inset currentColor;
  }

  .customLook .tagify__input {
    display: none;
  }
  .tagify.customLook {
    border-radius: 4px;
  }
</style>
